export default __webpack_public_path__ + "static/media/thumb.6e28d4d9.svg";